import api from '@/api/census';

export default {
    namespaced: true,
    state: {
        all: [],
    },

    getters: {},

    actions: {
        index ({commit}, query) {
            api.index(query).then(({data}) => {
                commit('INDEX', data);
            });
        },
        read ({commit}, id) {
            api.read(id).then(({data}) => {
                commit('READ', data);
            });
        },
        create ({commit}, formData) {
            return api.create(formData);
        },
        update ({commit}, formData) {
            api.update(formData).then(({data}) => {
                commit('READ', data);
            });
        },
        delete ({commit}, quoteId) {
            api.delete(quoteId).then(() => {
                commit('DELETE', quoteId);
            });
        },

        savePositions ({commit}, data) {
            api.savePositions(data).then(({data}) => {
                commit('INDEX', data);
            });
        }
    },

    mutations: {
        INDEX (state, responseData) {
            state.all = responseData;
        },
        READ (state, responseData) {

            const idx = state.all.findIndex(a => a.id == responseData.id);

            if (idx >= 0) {

                state.all.splice(idx, 1, responseData);
            } else {

                state.all.push(responseData);
            }
        },
        DELETE (state, quoteId) {
            state.all = state.all.filter(a => a.quote_id != quoteId);
        },

    }

};
